import { useRef } from 'react'

const Alert = (props) => {
	return (
		<div className='alert alert-warning text-center' role='alert'>
			{props.msg}
		</div>
	)
}

export default Alert
